import { useMemo } from 'react';

import { useCustomerCtx } from '@/app/(app)/customers/[id]/provider';
import { DateTimeInUTC } from '@/components/atoms/datetime';
import { ApiSchemas } from '@/components/providers/v1-api';
import { Badge } from '@/components/ui/badge';

export function CustomerAdminServiceTypes() {
  const { customer } = useCustomerCtx();

  return (
    <div className='flex flex-col gap-6'>
      <div className='flex items-center'>
        <div className='text-lg font-semibold'>Service Types</div>
      </div>
      <div className='flex flex-col gap-4'>
        {customer.service_types.map((serviceType) => (
          <ServiceTypeCard key={serviceType.id} serviceType={serviceType} />
        ))}
      </div>
    </div>
  );
}

function ServiceTypeCard({ serviceType }: { serviceType: ApiSchemas['ServiceTypeRead'] }) {
  const { customer } = useCustomerCtx();
  const servicePlan = useMemo(() => {
    if (!serviceType.service_plan_id) return null;
    return customer.service_plans.find((servicePlan) => servicePlan.id === serviceType.service_plan_id);
  }, [customer.service_plans, serviceType.service_plan_id]);

  return (
    <div className='flex w-full flex-col gap-4 rounded-4xl p-4 shadow-md'>
      <div className='flex items-center gap-3'>
        <div className='text-sm font-medium'>{serviceType.name}</div>
        <Badge variant='secondary'>{serviceType.status}</Badge>
      </div>
      <div className='border-t-[0.5px]'>
        <div className='flex items-center gap-2 py-2 not-last:border-b-[0.5px]'>
          <div className='w-40 text-sm text-muted-foreground'>Service Plan</div>
          <div className='text-sm'>{servicePlan?.name}</div>
        </div>
        <div className='flex items-center gap-2 py-2 not-last:border-b-[0.5px]'>
          <div className='w-40 text-sm text-muted-foreground'>Created At</div>
          <div className='text-sm'>
            <DateTimeInUTC value={serviceType.created_at} format='MMM d, yyyy h:mm a' />
          </div>
        </div>
        <div className='flex items-center gap-2 py-2 not-last:border-b-[0.5px]'>
          <div className='w-40 text-sm text-muted-foreground'>External Id</div>
          <div className='font-mono text-xs'>{serviceType.external_id}</div>
        </div>
      </div>
    </div>
  );
}
